import { Component, Vue } from "vue-property-decorator";

@Component
export default class DownloadReportError extends Vue {
  closeModal(): void {
    this.$bvModal.hide("downloadReportError");
  }
}
